module.exports = __webpack_public_path__ + "static/img/Receber-2020-72.fa6a800.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Receber-2020-72.png
// module id = +6s5
// module chunks = 0